import { fetchData } from "@client";

export async function getFAQsQuery(lang) {
  const res = await fetchData(`/faq?limit=1000&lang=${lang}`);
  return res.results;
}
